export default () => {
  const host = process.env.VUE_APP_CLIENT_LOCAL_HOST || 'localhost';

  const apiHost = `http://${host}:3000/trybstage/europe-west2`;
  const clientHost = `http://${host}:8080`;

  const baseURL = `${apiHost}/web`;
  const FB_APP_ID = '';

  const stripeConfig = {
    liveMode: false,
    publicKey: 'pk_test_51HuI4yCyaouDToD1egqNbpCkpl5YaciH4fDspl0wcdtBJtRCQekOJr66hMGVG3vF7I18YHdwJEHll7NQG1SH7Ixn00sheQO82r',
  };

  const firebaseConfig = {
    apiKey: 'AIzaSyDQ4qYz-K2wQzmGXaukh9SxYhMAVgsejGI',
    authDomain: 'trybstage.firebaseapp.com',
    databaseURL: 'https://trybstage.firebaseio.com',
    storageBucket: 'trybstage.appspot.com',

    projectId: 'trybstage',
    messagingSenderId: '269186549921',
    appId: '1:269186549921:web:65a757e9ccaf576ea188e0',
    measurementId: '',
  };

  const getTemplateCategories = () => import('@/constants/templates/templatesStaging').then(({ CATEGORIES }) => CATEGORIES);

  return {
    baseURL,
    clientHost,
    FB_APP_ID,
    firebaseConfig,
    stripeConfig,
    getTemplateCategories,
  };
};
